import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { types as api } from '@mesa-labs/mesa-api';

export type YieldMonitoringTableSort = {
  field: string;
  direction: api.SortDirection;
};

export type YieldMonitoringState = {
  search: string;
  vendorSort: YieldMonitoringTableSort;
  clientSort: YieldMonitoringTableSort;
  partnerSort: YieldMonitoringTableSort;
  vendorPage: number;
  clientPage: number;
  partnerPage: number;
  expandedVendors: string[];
  expandedClients: string[];
  expandedPartners: string[];
};

export const initialState: YieldMonitoringState = {
  search: '',
  vendorSort: { field: 'allTimeWeightedApr', direction: api.SortDirection.DESCENDING },
  clientSort: { field: 'allTimeWeightedApr', direction: api.SortDirection.DESCENDING },
  partnerSort: { field: 'allTimeWeightedApr', direction: api.SortDirection.DESCENDING },
  vendorPage: 1,
  clientPage: 1,
  partnerPage: 1,
  expandedVendors: [],
  expandedClients: [],
  expandedPartners: [],
};

const yieldMonitoringSlice = createSlice({
  name: 'yieldMonitoring',
  initialState,
  reducers: {
    updateSearch(state, action: PayloadAction<string>) {
      state.search = action.payload;
    },
    updateVendorSort(state, action: PayloadAction<YieldMonitoringTableSort>) {
      state.vendorSort = action.payload;
      state.vendorPage = 1;
    },
    updateClientSort(state, action: PayloadAction<YieldMonitoringTableSort>) {
      state.clientSort = action.payload;
      state.clientPage = 1;
    },
    updatePartnerSort(state, action: PayloadAction<YieldMonitoringTableSort>) {
      state.partnerSort = action.payload;
      state.partnerPage = 1;
    },
    setVendorPage(state, action: PayloadAction<number>) {
      state.vendorPage = action.payload;
    },
    setClientPage(state, action: PayloadAction<number>) {
      state.clientPage = action.payload;
    },
    setPartnerPage(state, action: PayloadAction<number>) {
      state.partnerPage = action.payload;
    },
    toggleVendorExpand(state, action: PayloadAction<string>) {
      const id = action.payload;
      const idx = state.expandedVendors.indexOf(id);
      if (idx >= 0) {
        state.expandedVendors.splice(idx, 1);
      } else {
        state.expandedVendors.push(id);
      }
    },
    toggleClientExpand(state, action: PayloadAction<string>) {
      const id = action.payload;
      const idx = state.expandedClients.indexOf(id);
      if (idx >= 0) {
        state.expandedClients.splice(idx, 1);
      } else {
        state.expandedClients.push(id);
      }
    },
    togglePartnerExpand(state, action: PayloadAction<string>) {
      const id = action.payload;
      const idx = state.expandedPartners.indexOf(id);
      if (idx >= 0) {
        state.expandedPartners.splice(idx, 1);
      } else {
        state.expandedPartners.push(id);
      }
    },
  },
});

export const {
  updateSearch,
  updateVendorSort,
  updateClientSort,
  updatePartnerSort,
  setVendorPage,
  setClientPage,
  setPartnerPage,
  toggleVendorExpand,
  toggleClientExpand,
  togglePartnerExpand,
} = yieldMonitoringSlice.actions;

export default yieldMonitoringSlice.reducer;
